import { createFileRoute } from "@tanstack/react-router"
import * as React from "react"
import { getProfile } from "@/collections/about/server"
import { Admonition } from "@/components/block/Admonition"
import { Container } from "@/components/layout/Container"
import { Header } from "@/components/layout/Header"
import SocialLinks from "@/features/social/components/SocialLinks"
import WhoIAmNotList from "@/features/social/components/WhoIAmNotList"
import { hastToJsx } from "@/utils/hast"
import { pageMeta } from "@/utils/seo"

export const Route = createFileRoute("/about/$lang")({
  component: AboutComponent,
  loader: ({ params }) => getProfile(params),
  head: ({ loaderData, params }) => ({
    meta: pageMeta({
      ogType: "article",
      title: loaderData ? `${loaderData.fullName} (${params.lang})` : `About (${params.lang})`,
      description: "About the author of jingsi.space. This page provides information about the author's background, social accounts, and website purpose.",
    }),
  }),
})

function AboutComponent() {
  const { taglineHast, descriptionHast, postscriptHast, socialLinks, whoIAmNotEntries } = Route.useLoaderData()
  const disclaimerId = React.useId()

  return (
    <Container>
      <Header>
        <h1 id="page-heading">About the Author</h1>
      </Header>

      <main aria-labelledby="page-heading" className="typography">
        <Admonition
          type="warning"
          title="Disclaimer: Not Intended for Recruitment"
          icon="⚠️"
          id={disclaimerId}
        >
          This page is intended for readers of this blog. It provides context about the author and the purpose of the website. It is not designed for recruitment or hiring inquiries.
        </Admonition>

        {hastToJsx(taglineHast)}

        <SocialLinks items={socialLinks} />

        {hastToJsx(descriptionHast)}

        {/* Under the Contract section */}
        <WhoIAmNotList entries={whoIAmNotEntries} />

        <hr />

        <h2>Trivium</h2>

        {hastToJsx(postscriptHast)}
      </main>
    </Container>
  )
}
